import React from "react";
import {Modal,Button,Panel,PanelGroup} from "react-bootstrap";
import menu from "../conf/menu"
import RequestsListComponent from "./helper_components/RequestsListComponent"
import CostPhotoListComponent from "./helper_components/CostPhotoListComponent";
import PaginationComponent from "./helper_components/PaginationComponent";
import filterValue from "../conf/words";
import CostImagePopup from "./helper_components/CostImagePopup";
import {checkTokenUtil, mapForObject} from "../utils";

class RequestsComponent extends React.Component{
  constructor(props){
    super(props);
    this.state = {
        isVisibleModal:false,
        isVisibleModalSumiagro:false,
        detail:{
            user:{},
            request:{}
        },
        startPageNumber: 0,
        endPageNumber: 5,
        pageNumberToShow:5,
        activePage:1,
        numberOfPage:10,
        transactionModal:false,
        revisionsModal:false,
        start:0,
        end:10,
        img:{
            show:false,
            src:""
        },
        filterStatus : "manager",
    };

    this.closeAction = this.closeAction.bind(this);
    this.infoButton = this.infoButton.bind(this);
    this.pagination = this.pagination.bind(this);
    this.costConfirmButton = this.costConfirmButton.bind(this);
    this.costCancelButton = this.costCancelButton.bind(this);
    this.setFilterAction = this.setFilterAction.bind(this);
    this.costImagePopupShow = this.costImagePopupShow.bind(this);
  }

  async componentDidMount(){
       await this.props.getManagerRequests(
          this.props.accessToken,
          "-1",
          this.refs.month.value,
          this.refs.year.value,
          this.refs.costStatusOption.value)
  }
    componentDidUpdate(prevProps,prevState){
        const result = checkTokenUtil()
    }
  async setFilterAction(filterValue){
      await this.props.getManagerRequests(
          this.props.accessToken,
          filterValue.employee,
          filterValue.month,
          filterValue.year,
          filterValue.status
      );
      this.state.filterStatus = filterValue.status
      this.state.detail.user._id = filterValue.employee
  }

  closeAction(){
    this.setState({
      isVisibleModal:false,
      isVisibleModalSumiagro:false
    });
  }
  closeRevisionsModal(){
    const formType = this.state.detail.request.formType;
    if(formType === "applicationSumiagro" || formType === "settlementSumiagro"){
      this.setState({
        revisionsModal:false,
        isVisibleModalSumiagro:true
      })
    }else{
      this.setState({
        revisionsModal:false,
        isVisibleModal:true
      })
    }
  }
  infoButton(user,request){
    if(request.formType === "applicationSumiagro" || request.formType === "settlementSumiagro"){
      this.setState({isVisibleModalSumiagro:true})
    }else{
      this.setState({isVisibleModal:true})
    }
    this.setState({
      detail:{
        user:user,
        request:request
      }
    });
  }

  pagination(){
    const {activePage,numberOfPage} = this.state;
    const {requestsList} = this.props;
    let pageIndex = (activePage * numberOfPage) - numberOfPage;
    let pageTotal = requestsList.length - (activePage * numberOfPage);
    if(pageTotal < 0){
      pageTotal = requestsList.length;
    }else{
      pageTotal = pageIndex + numberOfPage;
    }
    return {
      totalPage: Math.ceil(requestsList.length / numberOfPage),
      start:pageIndex,
      finish:pageTotal
    }
  }

  costConfirmButton(bool = false,user,costData){
    if(bool){
        this.props.confirmAllCostsButtonAction(
            this.props.accessToken,
            this.refs.month.value,
            this.refs.year.value,
            this.refs.costStatusOption.value,
            this.refs.employees.value
        );
    }else {
        const employeeFilter = this.refs.employees.value
        this.props.costConfirmAction(user,costData,this.props.accessToken,employeeFilter,this.closeAction,);
    }
  }

  costCancelButton(user,costData){
    this.props.costCancelAction(this.props.accessToken,user,costData,this.closeAction);
  }

  costImagePopupShow(src){
    this.setState({
      img:{
        show:true,
        src:src
      }
    })
  }

  render(){
    const {totalPage,start,finish} = this.pagination();
    const {requestsList,employeeList,t} = this.props;
    let {user,request} = this.state.detail;
    request.costPhotos = (request.costPhotos ? request.costPhotos : []);
    const context = this;
    let year = [];
    for(let i = window.costStartingYear;i<=new Date().getFullYear();i++){
      year.push(<option key={i} value={i}>{i}</option>);
    }
    document.title = t(menu[this.props.location.pathname])+" - masraf.dakika.com.tr";
    if(!request.revisions)
      request.revisions = [];
    return (
      <div className="content">
        {
          /*
            Cost Image Popup
          */
        }
        <CostImagePopup  t={t} closeButton={() => {
            this.setState({
              img:{
                show:false,
                src:""
              }
            })
          }} show={this.state.img.show} src={this.state.img.src}/>
           <Modal show={this.state.isVisibleModalSumiagro}>
          <Modal.Header closeButton onHide={this.closeAction}>
            <Modal.Title id="contained-modal-title">{t("costDetail")} / <span className="costForUsername">{user.employeeName}</span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <table className="table table-hover table-bordered">
              <tbody>
              <tr>
                  <td>{t("costFormType")}</td>
                  <td><h6>{request.formType === "applicationSumiagro" ? "Application" : "Settlement"}</h6></td>
              </tr>
              <tr>
                  <td>{t("costDate")}</td>
                  <td><span>{request.costDate}</span></td>
              </tr>
              <tr>
                  <td>{t("invoiceNo")}</td>
                  <td><span>{request.invoiceNo}</span></td>
              </tr>
              <tr>
                  <td>{t("costType")}</td>
                  <td><span>{request.costType}</span></td>
              </tr>

              {
                  request.formType === "settlementSumiagro" ? (
                      <>
                          <tr>
                              <td>{t("preApprovedBudget")}</td>
                              <td><span>{request.preApprovedBudget}</span></td>
                          </tr>
                          <tr>
                              <td>{t("actualExpenditure")}</td>
                              <td><span>{request.costAmount}</span></td>
                          </tr>
                      </>
                  ) : (
                      <tr>
                          <td>{t("costAmount")}</td>
                          <td><span>{request.costAmount}</span></td>
                      </tr>
                  )
              }
              <tr>
                  <td>{t("company")}</td>
                  <td><span>{request.companyName}</span></td>
              </tr>
              <tr>
                  <td>{t("place")}</td>
                  <td><span>{request.placeName}</span></td>
              </tr>
              <tr>
                  <td>{t("guests")}</td>
                  <td><span>{request.guestName}</span></td>
              </tr>
              <tr>
                  <td>{t("guestNumber")}</td>
                  <td><span>{request.guestNumber}</span></td>
              </tr>
              <tr>
                  <td>{t("staff")}</td>
                  <td><span>{request.staffName}</span></td>
              </tr>
              <tr>
                  <td>{t("staffNumber")}</td>
                  <td><span>{request.staffNumber}</span></td>
              </tr>
              <tr>
                  <td>{t("otherParticipants")}</td>
                  <td><span>{request.otherParticipant}</span></td>
              </tr>
              <tr>
                  <td>{t("otherParticipantNumber")}</td>
                  <td><span>{request.otherParticipantNumber}</span></td>
              </tr>
              <tr>
                  <td>{t("currencyUnit")}</td>
                  <td><span>{request.moneyType}</span></td>
              </tr>
              <tr>
                  <td>{t("paymentType")}</td>
                  <td><span>{request.paymentType}</span></td>
              </tr>
              {request.costCategory ?
                  <tr>
                      <td>{t("costCategory")}</td>
                      <td><span>{request.costCategory}</span></td>
                  </tr> : null
              }
              {
                  request.kdvOrani
                      ?
                      <tr>
                          <td>{t("vatRate")}</td>
                          <td><span>{request.kdvOrani}</span></td>
                      </tr>
                      :
                      null
              }
              <tr>
                  <td>{t("supplierName")}</td>
                  <td><span>{request.supplierName}</span></td>
              </tr>
              <tr>
                  <td>{t("description")}</td>
                  <td><span>{request.costDescription}</span></td>
              </tr>
              <tr>
                  <td>{t("isPublicServant")}</td>
                  <td><span>{request.isPublicServant}</span></td>
              </tr>
              <tr>
                  <td>{t("photos")}</td>
                  <td>
                      <div className="row">
                          {
                              request.costPhotos.length > 0
                                  ?
                                  request.costPhotos.map((d, k) => {
                                      return <CostPhotoListComponent t={t} costImagePopupShow={(src) => {
                                          this.costImagePopupShow(src)
                                      }} photo={d} key={k}/>
                                  })
                                  :
                                  <h6 className="title" style={{paddingLeft: "10px"}}>{t("photoIsNotUploadded")}</h6>
                          }
                      </div>
                  </td>
              </tr>
              {
                  request.status == "cancel"
                      ?
                      <tr>
                          <td>{t("reasonForCancellation")}:</td>
                          <td><span className="cancelText">{request.costCancelDescription}</span></td>
                      </tr>
                      :
                      null
              }
              </tbody>
          </table>
          </Modal.Body>
               <Modal.Footer>
                   <div className="row">
                       <div className="col-md-2">
                       <Button className="btn btn-warning btn-fill btn-wd" onClick={() => {
                  this.setState({
                    revisionsModal:true,
                    isVisibleModalSumiagro:false
                  })
                }}>{t("revisions")}</Button>
            </div>
            <div className="col-md-10">
              {
                request.status == "manager"
                ?
                <div>
                  <Button onClick = {() => {this.costConfirmButton(false,user,request)}} className="btn btn-wd btn-success"><span className="btn-label"><i className="fa fa-check"></i></span> {t("approveCost")}</Button>
                  <Button onClick = {() => {this.costCancelButton(user,request);}} className="btn btn-wd btn-danger"><span className="btn-label"><i className="fa fa-times"></i></span>{t("rejectCost")}</Button>
                </div>
                :
                null
              }
            </div>
          </div>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.isVisibleModal}>
          <Modal.Header closeButton onHide={this.closeAction}>
            <Modal.Title id="contained-modal-title">{t('costDetail')} / <span className="costForUsername">{user.employeeName}</span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover table-bordered">
              <tbody>
                <tr>
                  <td>{t('costDate')}</td>
                  <td><span>{request.costDate}</span></td>
                </tr>
                <tr>
                  <td>{t('invoiceNo')}</td>
                  <td><span>{request.invoiceNo}</span></td>
                </tr>
                <tr>
                  <td>{t('costType')}</td>
                  <td><span>{request.costType}</span></td>
                </tr>
                <tr>
                  <td>{t('costAmount')}</td>
                  <td><span>{request.costAmount}</span></td>
                </tr>
                <tr>
                  <td>{t('currencyUnit')}</td>
                  <td><span>{request.moneyType}</span></td>
                </tr>
                {
                    request.costLocation  ?
                    <tr>
                        <td>{t('costKind')}</td>
                        <td><span>{request.costLocation}</span></td>
                    </tr>
                        :null
                }
                {
                    request.costCategory ?
                    <tr>
                        <td>{t('costCategory')}</td>
                        <td><span>{request.costCategory}</span></td>
                    </tr>
                    :null
                }
                <tr>
                  <td>{t('paymentType')}</td>
                  <td><span>{request.paymentType}</span></td>
                </tr>
                <tr>
                  <td>{t('supplierName')}</td>
                  <td><span>{request.supplierName}</span></td>
                </tr>
                <tr>
                  <td>{t('description')}</td>
                  <td><span>{request.costDescription}</span></td>
                </tr>
                <tr>
                  <td>{t('photos')}</td>
                  <td><div className="row">
                    {
                      request.costPhotos.length > 0
                      ?
                        request.costPhotos.map((d,k) => {
                          return <CostPhotoListComponent t={t} costImagePopupShow={(src) => {this.costImagePopupShow(src)}} photo={d} key={k}/>
                        })
                      :
                      <h6 className="title" style={{paddingLeft:"10px"}}>{t('photoIsNotUploadded')}</h6>
                    }
                  </div></td>
                </tr>
                {
                  request.status == "cancel"
                  ?
                  <tr>
                    <td>{t('reasonForCancellation')}: </td>
                    <td><span className="cancelText">{request.costCancelDescription}</span></td>
                  </tr>
                  :
                  null
                }
              </tbody>
           </table>
          </Modal.Body>
          <Modal.Footer>
          <div className="row">
            <div className="col-md-2">
              <Button className="btn btn-warning btn-fill btn-wd" onClick={() => {
                  this.setState({
                    revisionsModal:true,
                    isVisibleModal:false
                  })
                }}>{t('revisions')}</Button>
            </div>
            <div className="col-md-10">
              {
                request.status == "manager"
                ?
                <div>
                  <Button onClick = {() => {this.costConfirmButton(false,user,request)}} className="btn btn-wd btn-success"><span className="btn-label"><i className="fa fa-check"></i></span> {t('approveCost')}</Button>
                  <Button onClick = {() => {this.costCancelButton(user,request);}} className="btn btn-wd btn-danger"><span className="btn-label"><i className="fa fa-times"></i></span>{t('rejectCost')}</Button>
                </div>
                :
                null
              }
            </div>
          </div>
          </Modal.Footer>
        </Modal>
        {
          /*
            Revize Modal
          */
        }
        <Modal show={this.state.revisionsModal}>
          <Modal.Header closeButton onHide={() => {
              this.setState({
                revisionsModal:false
              })
            }}>
            <Modal.Title id="contained-modal-title">{t('revisions')} / <span className="costForUsername" dangerouslySetInnerHTML={{__html: t('totalRevision',{length: request.revisions ? request.revisions.length : null})}}></span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PanelGroup>
              {
                request.revisions.length > 0
                ?
                request.revisions.map((fields,key) => {
                  return (
                    <Panel key={key} collapsible header={fields.date} eventKey={key}>
                      <table className="table table-hover table-bordered">
                        <tbody>
                          {
                            Object.keys(fields.fields).length > 0
                            ?
                              mapForObject(fields.fields,(data,index,key2) => {
                                var nextData = [];
                                var incrementKey = key+1;
                                while(incrementKey < request.revisions.length){
                                  nextData = mapForObject(request.revisions[incrementKey].fields,index);
                                  if(typeof nextData != "object")
                                    break;
                                  incrementKey++;
                                }
                                if(typeof nextData === "object")
                                  nextData = request[index];
                                return (
                                  <tr key={key2}>
                                    <td>{t(filterValue.costFields[index])}</td>
                                    <td><strong className="darkred">{data}</strong> / <strong className="green">{nextData}</strong></td>
                                  </tr>
                                )
                              })
                            :
                            <tr>
                              <td>{t('notUpdatedData')}</td>
                            </tr>
                          }
                        </tbody>
                     </table>
                    </Panel>

                  )
                })
                :
                null
              }
            </PanelGroup>
          </Modal.Body>
          <Modal.Footer style={{textAlign:"left"}}>
            <button type="button" onClick={() => this.closeRevisionsModal()} className="btn btn-wd btn-default"><span className="btn-label"><i className="fa fa-arrow-left"></i></span>{t('back')}</button>
          </Modal.Footer>
        </Modal>
        {
          /*
            İşlem Modal
          */
        }
        <Modal show={this.state.transactionModal}>
          <Modal.Header closeButton onHide={() => {
              this.setState({
                transactionModal:false
              })
            }}>
            <Modal.Title id="contained-modal-title">{t('transactions')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PanelGroup>
              {
                request.transactions
                ?
                request.transactions.map((fields,key) => {
                  return (
                    <Panel style={{padding: "10px 10px 0px 10px"}} key={key} collapsible header={fields.transactionDate+" - "+ fields.employeeName} eventKey={key}>
                      <p className="p">
                        <strong className="employeeName">{fields.employeeName},</strong>
                        <span dangerouslySetInnerHTML={{
                          __html: t('approvedRejectedDate',
                          {
                            date:fields.transactionDate,
                            time:fields.transactionTime,
                            transactionType: fields.transactionType == 1 ? t('approvedTransactions') : t('rejectedTransactions')
                          })}}></span>
                      </p>
                    </Panel>
                  )
                })
                :
                null
              }
            </PanelGroup>
          </Modal.Body>
        </Modal>
        <div className="container-fluid">
          <div className="card">
              <div className="content">
                <div className="row">
                   <div className="col-md-3" >
                        <select id="managerConfirmationCostEmployeeSelectButton" ref="employees" onChange={(e) => {
                            this.setFilterAction({
                                status: this.refs.costStatusOption.value,
                                month: this.refs.month.value,
                                year:this.refs.year.value,
                                employee:e.target.value
                            })
                        }} className="form-control input-sm border-input filterSelect">
                            <option value="-1">{t('selectPersonnel')}</option>
                            {
                                employeeList.map((employee,index) => <option key={index} value={employee._id}>{employee.employeeName}</option>)
                            }
                        </select>
                    </div>
                  <div className="col-md-3">
                    <select id="managerConfirmationCostStatusSelectButton" ref="costStatusOption" defaultValue={this.props.filter.status} onChange={(e) => {
                        this.setFilterAction({
                          status: e.target.value,
                          month: this.refs.month.value,
                          year: this.refs.year.value,
                          employee: this.refs.employees.value
                        })
                      }} className="form-control input-sm border-input filterSelect">
                      <option value="manager">{t('awaitingApproval')}</option>
                      <option value="approved">{t('approvedCosts')}</option>
                      <option value="cancel">{t('rejects')}</option>
                    </select>
                  </div>
                    <div className="col-md-2">
                      <select id="managerConfirmationCostMonthSelectButton" ref="month" defaultValue={this.props.filter.month} onChange={(e) => {
                          this.setFilterAction({
                            status: this.refs.costStatusOption.value,
                            month: e.target.value,
                            year: this.refs.year.value,
                              employee: this.refs.employees.value
                          })
                        }} className="form-control input-sm border-input filterSelect">
                         <option value="-1">{t('selectMonth')}</option>
                         <option value="01">{t('jan')}</option>
                         <option value="02">{t('feb')}</option>
                         <option value="03">{t('mar')}</option>
                         <option value="04">{t('apr')}</option>
                         <option value="05">{t('may')}</option>
                         <option value="06">{t('jun')}</option>
                         <option value="07">{t('jul')}</option>
                         <option value="08">{t('aug')}</option>
                         <option value="09">{t('sep')}</option>
                         <option value="10">{t('oct')}</option>
                         <option value="11">{t('nov')}</option>
                         <option value="12">{t('dec')}</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <select id="managerConfirmationCostYearSelectButton" onChange={(e) => {
                          this.setFilterAction({
                            status: this.refs.costStatusOption.value,
                            month: this.refs.month.value,
                            year: e.target.value,
                            employee: this.refs.employees.value
                          })
                        }} ref="year" defaultValue={this.props.filter.year} className="form-control input-sm border-input filterSelect">
                        <option value="-1">{t('selectYear')}</option>
                        {year}
                      </select>
                    </div>
                </div>
              </div>
          </div>
          <div className="card costList">
              <div className="header">
                  <h4 className="title">{t('expenses')}</h4>
              </div>
              <div className="content">
                <div className="content table-responsive table-full-width">
                    <table className="table table-striped">
                        <thead>
                          <tr>
                          <th>{t('employee')}</th>
                          <th>{t('invoice')}</th>
                          <th>{t('costType')}</th>
                          <th>{t('costDate')}</th>
                          <th>{t('creationDate')}</th>
                          <th>{t('amount')}</th>
                          <th></th>
                          </tr>
                        </thead>
                        <tbody id="managerConfirmationCostList">
                          {
                            requestsList.length > 0
                            ?
                            requestsList.slice(start,finish).map((cost,key) => {
                              if(cost.user.employeeID != this.props.employeeID)
                                return (<RequestsListComponent t={t} key={key} transactionsButton={(user,cost) => {this.setState({transactionModal:true,detail:{user:user,request:cost}})}} buttonsActions={[this.costConfirmButton,this.costCancelButton]} photoDelete="false" infoButton={this.infoButton} data={cost.costs} manager={cost.manager} user={cost.user} parent={context}
                                mstatus={this.state.filterStatus}
                                />)
                            })
                            :
                            null
                          }
                          {
                            this.props.filter.status == "manager" && requestsList.length > 0

                            ?
                            <tr>
                                {this.state.filterStatus == "manager" ? <td colSpan="7" style={{textAlign:"center"}}>
                            <button onClick={() => { this.costConfirmButton(true) }} type="button" style={{ minWidth: "30%" }} id="managerConfirmationConfirmAll" className="btn btn-wd btn-success">
                                    <span className="btn-label"><i className="fa fa-check"></i>
                                    </span> {t('approveAll')}
                                    </button></td> : null }
                            </tr>
                            :
                            null
                          }

                        </tbody>
                    </table>
                </div>
              </div>
          </div>
            <div className="card">
              <div className="content">
                <PaginationComponent t={t} endPageNumber={this.state.endPageNumber} startPageNumber={this.state.startPageNumber} pageNumberToShow={this.state.pageNumberToShow} parent={this} activePage={this.state.activePage} numberOfPage={this.state.numberOfPage} totalPage={totalPage} data={requestsList}/>
              </div>
            </div>
        </div>
    </div>
    )
  }
};

export default RequestsComponent;
